import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as BackArrow } from "../../Icons/BorderBackArrow.svg";
import { Box, Typography } from "@mui/material";
import { PrimaryTypography } from "../../Theme";

import { useNavigate } from "react-router-dom";
import CompanyDetails from "./SalesOverviewforms/CompanyDetails";
import ReviewAccount from "./SalesOverviewforms/ReviewAccount";
import AdministratorDetails from "./SalesOverviewforms/AdministratorDetails";
import ProjectInformation from "./SalesOverviewforms/ProjectInformation";
import axiosInstance from "../../AxiosInstance";
import { emailRegex } from "../../utils/common";
import { useDialog } from "../../contexts/DialogContext";

import { showToast } from "../../CommonComponents/Toaster";
import {
  validateAdministratorDetails,
  validateCompanyDetails,
  validateProjectDetails,
} from "../../utils/validate";
import moment from "moment";

const CreateNewAccount = () => {
  const [addblocks, setaddblocks] = useState({
    Company_Details: true,
    Project_Information: false,
    Administrator_Details: false,
    Review_Account: false,
  });
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [disable, setDisable] = useState(false);
  const [trialDisable, setTrialDisable] = useState(false);
  const [triggerKey, setTriggerKey] = useState(0);
  const [openAddCompanyDialog, setOpenAddCompanyDialog] = useState(false);
  const [administratorDetails, setAdministratorDetails] = useState({
    full_name: "",
    email_address: "",
  });
  const topRef = useRef(null);
  const [administratorErrText, setAdministratorErrText] = useState({
    full_name: "",
    email_address: "",
  });
  const [loading, setLoading] = useState(false);
  const [PDF, setPDF] = useState({
    fileName: "",
    fileSize: "",
    path: "",
  });

  const { showDialog } = useDialog();
  const [companyDetails, setCompanyDetails] = useState({
    company_category: "",
    company_name: "",
    company_country: "",
    company_email_address: "",
    company_contact_number: "",
    company_address: "",
    company_country_code: "",
    company_type: "",
    billing_entity: "",
    billing_full_name: "",
    billing_email_address: "",
    billing_cycle: "",
    billing_cycle_id: "",
    billing_contact_number: "",
    billing_contract_terms: "",
    billing_country_code: "",
    billing_commence_date: null,
    billing_end_date: null,
    contract: "",
  });
  const [projectDetails, setProjectDetails] = useState({
    project_title: "",
    type: "",
    completion_year: "",
    tenure: "",
    units: "",
    address: "",
    country: "",
    city: "",
    postal_code: "",
    full_name: "",
    email_address: "",
    position: "",
    contact_number: "",
    country_code: "",
  });
  const [projectDetailsErrText, setProjectDetailsErrText] = useState({
    project_title: "",
    type: "",
    completion_year: "",
    tenure: "",
    units: "",
    address: "",
    country: "",
    city: "",
    postal_code: "",
    full_name: "",
    email_address: "",
    position: "",
    contact_number: "",
  });
  const [companies, setCompanies] = useState([]);
  const [billingCycle, selectBillingCycle] = useState([]);
  const [projectTypes, setProjectTypes] = useState([]);
  const [companyDetailsErrText, setCompanyDetailsErrText] = useState({
    company_category: "",
    company_name: "",
    company_country: "",
    company_email_address: "",
    company_contact_number: "",
    company_address: "",
    company_country_code: "",

    billing_entity: "",
    billing_full_name: "",
    billing_email_address: "",
    billing_cycle: "",

    billing_contact_number: "",
    billing_contract_terms: "",
    billing_country_code: "",
    billing_commence_date: "",
    billing_end_date: "",
    contract: "",
  });

  const navigate = useNavigate();

  const blocks = [
    { status: addblocks.Company_Details, tle: "Company Details" },
    { status: addblocks.Project_Information, tle: "Project Information" },
    { status: addblocks.Administrator_Details, tle: "Administrator Details" },
    { status: addblocks.Review_Account, tle: "Review Account" },
  ];

  const Continue = (nxtval) => {
    if (nxtval === "Company Details") {
      setaddblocks({
        Company_Details: true,
        Project_Information: false,
        Administrator_Details: false,
        Review_Account: false,
      });
    }

    if (nxtval === "Project Information") {
      if (
        validateCompanyDetails(
          companyDetails,
          PDF,
          companyDetailsErrText,
          setCompanyDetailsErrText,
          trialDisable
        )
      ) {
        setaddblocks({
          Company_Details: false,
          Project_Information: true,
          Administrator_Details: false,
          Review_Account: false,
        });
      }
    }
    if (nxtval === "Administrator Details") {
      if (
        validateCompanyDetails(
          companyDetails,
          PDF,
          companyDetailsErrText,
          setCompanyDetailsErrText,
          trialDisable
        ) &&
        validateProjectDetails(
          projectDetails,
          projectDetailsErrText,
          setProjectDetailsErrText
        )
      ) {
        setaddblocks({
          Company_Details: false,
          Project_Information: false,
          Administrator_Details: true,
          Review_Account: false,
        });
      }
    }
    if (nxtval === "Review Account") {
      if (
        validateCompanyDetails(
          companyDetails,
          PDF,
          companyDetailsErrText,
          setCompanyDetailsErrText,
          trialDisable
        ) &&
        validateProjectDetails(
          projectDetails,
          projectDetailsErrText,
          setProjectDetailsErrText
        ) &&
        validateAdministratorDetails(
          administratorDetails,
          administratorErrText,
          setAdministratorErrText
        )
      ) {
        setaddblocks({
          Company_Details: false,
          Project_Information: false,
          Administrator_Details: false,
          Review_Account: true,
        });
      }
    }
  };
  const getCompanyData = () => {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}company`)
      .then((res) => {
        const companyData = res?.data?.data?.companies?.map((value) => ({
          label: value?.name,
          id: value?.id,
        }));
        console.log("companyData", companyData);
        setCompanies([...companyData, { label: "Add New Company", id: null }]);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getbillingCycleData = () => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}getDropDownDatas?type=property_billing_cycle`
      )
      .then((res) => {
        selectBillingCycle(res?.data?.data?.drop_down || []);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getProjectType = () => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}getDropDownDatas?type=property_type`
      )
      .then((res) => {
        console.log("projectType", res?.data?.data?.drop_down);
        setProjectTypes(res?.data?.data?.drop_down || []);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (topRef.current) {
      topRef.current.scrollIntoView({
        behavior: "smooth",
      });
    }
  }, [addblocks]);
  useEffect(() => {
    getCompanyData();
    getbillingCycleData();
    getProjectType();
  }, []);

  useEffect(() => {
    if (companyDetails?.billing_cycle?.id === 4) {
      setCompanyDetails((prev) => ({
        ...prev,
        billing_contract_terms: "0 Years 1 months",
      }));
      setCompanyDetailsErrText((prev) => ({
        ...prev,
        billing_contract_terms: "",
      }));
      setTrialDisable(true);
      if (companyDetails?.billing_commence_date) {
        const commenceDate = moment(companyDetails.billing_commence_date);
        const endDate = commenceDate.clone().add(30, "days");

        // Update state or use the new date
        setCompanyDetails((prev) => ({
          ...prev,
          billing_end_date: endDate, // Save formatted date
        }));
        setCompanyDetailsErrText((prev) => ({
          ...prev,
          billing_end_date: "",
        }));
      }
    } else {
      setCompanyDetails((prev) => ({
        ...prev,
        billing_contract_terms: "",
      }));
      setTrialDisable(false);
    }
  }, [companyDetails?.billing_cycle, companyDetails?.billing_commence_date]);

  const handleSubmit = async () => {
    setLoading(true);
    const [years, months] = companyDetails?.billing_contract_terms
      .split(" ")
      .filter((item, index) => index === 0 || index === 2); // Get first and third items

    const contract_terms = {
      years: Number(years),
      months: Number(months),
    };

    const formData = new FormData();

    formData.append("title", projectDetails?.project_title);
    formData.append("type", projectDetails?.type?.id);
    formData.append("completion_year", Number(projectDetails?.completion_year));
    formData.append("tenure_year", projectDetails?.tenure);
    formData.append("total_units", projectDetails?.units);

    // Administrator details
    formData.append("name", administratorDetails?.full_name);
    formData.append("email", administratorDetails?.email_address);
    formData.append(
      "phone",
      `${projectDetails?.contact_number.slice(
        projectDetails?.country_code?.length
      )}`
    );
    formData.append("country_code", projectDetails?.country_code);
    formData.append("address", projectDetails?.address);
    formData.append("country", projectDetails?.country);
    formData.append("city", projectDetails?.city);
    formData.append("zipcode", projectDetails?.postal_code);

    // Billing details
    formData.append("billing_details[entity]", companyDetails?.billing_entity);
    formData.append("billing_details[name]", companyDetails?.billing_full_name);
    formData.append(
      "billing_details[email]",
      companyDetails?.billing_email_address
    );
    formData.append(
      "billing_details[country_code]",
      `${companyDetails?.billing_country_code}`
    );
    formData.append(
      "billing_details[phone]",
      companyDetails?.billing_contact_number.slice(
        companyDetails?.billing_country_code.length
      )
    );
    formData.append(
      "billing_details[billing_cycle]",
      companyDetails?.billing_cycle?.id
    );
    formData.append(
      "billing_details[contract_terms_year]",
      contract_terms?.years
    );
    if (companyDetails?.contract) {
      formData.append(
        "billing_details[contract_doc]",
        companyDetails?.contract
      );
    }
    formData.append(
      "billing_details[contract_terms_month]",
      contract_terms?.months
    );
    formData.append(
      "billing_details[commence_date]",
      companyDetails?.billing_commence_date
        ? companyDetails?.billing_commence_date
        : ""
    );
    formData.append(
      "billing_details[end_date]",
      companyDetails?.billing_end_date ? companyDetails?.billing_end_date : ""
    );
    // formData.append("billing_details[contract_doc]", companyDetails?.contract);

    // Contact details
    formData.append("contact_details[name]", projectDetails?.full_name);
    formData.append("contact_details[position]", projectDetails?.position);
    formData.append("contact_details[email]", projectDetails?.email_address);
    formData.append(
      "contact_details[country_code]",
      `${projectDetails?.country_code}`
    );
    formData.append(
      "contact_details[phone]",
      projectDetails?.contact_number.slice(projectDetails?.country_code.length)
    );

    if (companyDetails?.company_category?.id) {
      formData.append("company[id]", companyDetails?.company_category?.id);
    } else {
      // Company details
      formData.append("company[name]", companyDetails?.company_name);
      formData.append("company[email]", companyDetails?.company_email_address);
      formData.append(
        "company[country_code]",
        `${companyDetails?.company_country_code}`
      );
      formData.append(
        "company[phone]",
        companyDetails?.company_contact_number.slice(
          companyDetails?.company_country_code.length
        )
      );
      formData.append("company[address]", companyDetails?.company_address);
      formData.append("company[country]", companyDetails?.company_country);
    }
    // Log FormData
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}property`,
        formData,
        {
          "Content-Type": "multipart/form-data", // Ensure correct content type for FormData
        }
      );
      // navigate("/company");
      if (response?.status === 201) {
        navigate("/sales-overview");
        showDialog({
          title: "Account Created",
          content:
            "This account has been successfully created.  Development team will now prepare onboarding",
        });
      }
      setLoading(false);

      console.log(response.data);
    } catch (error) {
      console.error(error);
      if (error.response) {
        if (error.response.status === 400) {
          const { validation_error } = error.response.data?.data;

          if (validation_error) {
            const updatedCompanyErrText = { ...companyDetailsErrText };
            const updatedAdministratorErrText = { ...administratorErrText };
            const updatedProjectErrText = { ...projectDetailsErrText };
            Object.keys(validation_error).forEach((key) => {
              if (key === "company.name") {
                updatedCompanyErrText.company_name =
                  "Company name is already existed";
                setaddblocks({
                  Company_Details: true,
                  Project_Information: false,
                  Administrator_Details: false,
                  Review_Account: false,
                });
                setCompanyDetailsErrText(updatedCompanyErrText);
                showToast("Company name is already existed", "error");
              }
              if (key === "title") {
                updatedProjectErrText.project_title =
                  "Project Title is already existed";
                setaddblocks({
                  Company_Details: false,
                  Project_Information: true,
                  Administrator_Details: false,
                  Review_Account: false,
                });
                setProjectDetailsErrText(updatedProjectErrText);
                showToast("Project Title is already existed", "error");
              }
              if (key === "name") {
                updatedAdministratorErrText.full_name =
                  "Full Name is already existed";
                setaddblocks({
                  Company_Details: false,
                  Project_Information: false,
                  Administrator_Details: true,
                  Review_Account: false,
                });
                setAdministratorErrText(updatedAdministratorErrText);
                showToast("Full Name is already existed", "error");
              }
              if (key === "email") {
                updatedAdministratorErrText.email_address =
                  "Email is already existed";
                setaddblocks({
                  Company_Details: false,
                  Project_Information: false,
                  Administrator_Details: true,
                  Review_Account: false,
                });
                setAdministratorErrText(updatedAdministratorErrText);
                showToast("Email is already existed", "error");
              }
            });
          }
        } else {
          showToast("Something went wrong! Please try again.", "error");
        }
      }

      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  console.log("ds", companyDetails?.contract);
  const RenderComponent = () => {
    switch (true) {
      case addblocks.Company_Details:
        return (
          <CompanyDetails
            companyDetails={companyDetails}
            setCompanyDetails={setCompanyDetails}
            setCompanyDetailsErrText={setCompanyDetailsErrText}
            companyDetailsErrText={companyDetailsErrText}
            companies={companies}
            setaddblocks={setaddblocks}
            billingCycle={billingCycle}
            categoryLoading={categoryLoading}
            disable={disable}
            PDF={PDF}
            setPDF={setPDF}
            open={openAddCompanyDialog}
            setOpen={setOpenAddCompanyDialog}
            setTriggerKey={setTriggerKey}
            getCompanyData={getCompanyData}
            trialDisable={trialDisable}
          />
        );
      case addblocks.Project_Information:
        return (
          <ProjectInformation
            projectDetails={projectDetails}
            setProjectDetails={setProjectDetails}
            setaddblocks={setaddblocks}
            setProjectDetailsErrText={setProjectDetailsErrText}
            projectDetailsErrText={projectDetailsErrText}
            projectTypes={projectTypes}
          />
        );
      case addblocks.Administrator_Details:
        return (
          <AdministratorDetails
            administratorDetails={administratorDetails}
            setaddblocks={setaddblocks}
            setAdministratorDetails={setAdministratorDetails}
            administratorErrText={administratorErrText}
            setAdministratorErrText={setAdministratorErrText}
          />
        );
      case addblocks.Review_Account:
        return (
          <ReviewAccount
            companyDetails={companyDetails}
            projectDetails={projectDetails}
            administratorDetails={administratorDetails}
            setaddblocks={setaddblocks}
            handleSubmit={handleSubmit}
            loading={loading}
          />
        );

      default:
        return null;
    }
  };
  const getCompanyDataById = (id) => {
    setCategoryLoading(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}company/${id}`)
      .then((res) => {
        if (res?.status === 200) {
          setCompanyDetails((prev) => ({
            ...prev,
            company_name: res.data?.data?.company?.name,
            company_country: res?.data?.data?.company?.country,
            company_email_address: res?.data?.data?.company?.email,
            company_contact_number: `${res?.data?.data?.company?.country_code}${res?.data?.data?.company?.phone}`,
            company_country_code: res?.data?.data?.company?.country_code,
            company_address: res?.data?.data?.company?.address,
          }));
          setCompanyDetailsErrText((prev) => ({
            ...prev,
            company_name: "",
            company_country: "",
            company_email_address: "",
            company_contact_number: "",
            company_country_code: "",
            company_address: "",
          }));
          setCategoryLoading(false);

          setDisable(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setCategoryLoading(false);
      });
  };

  console.log("key", triggerKey);
  useEffect(() => {
    console.log("key", triggerKey);
    if (companyDetails?.company_category?.label === "Add New Company") {
      setOpenAddCompanyDialog(true);
      setCompanyDetails((prev) => ({
        ...prev,
        company_category: "",
        company_name: "",
        company_country: "",
        company_email_address: "",
        company_contact_number: "",
        company_country_code: "",
        company_address: "",
      }));
      setDisable(false);
    } else if (companyDetails?.company_category?.id) {
      getCompanyDataById(companyDetails?.company_category?.id);
    }
  }, [companyDetails?.company_category, triggerKey]);
  console.log("trigger", companyDetails?.company_category);
  return (
    <div ref={topRef}>
      <Box>
        <BackArrow
          onClick={() => navigate("/sales-overview")}
          style={{ marginBottom: "20px", cursor: "pointer" }}
        />
        <PrimaryTypography>Add New Account</PrimaryTypography>
      </Box>
      <Box sx={{ marginTop: "30px" }} display="flex" gap="1.5%" mb={5}>
        {blocks.map((itm) => (
          <Box
            key={itm.tle}
            onClick={() => Continue(itm.tle)}
            sx={{
              borderTop: itm.status ? "3px solid #0E4965" : "3px solid #D2D6DB",
              width: "25%",
              color: itm.status ? "#0E4965" : "#D2D6DB",
              cursor: "pointer",
            }}
          >
            <Typography
              sx={{
                fontWeight: "500",
                fontSize: "12px",
                color: itm.status ? "#0E4965" : "#9DA4AE",
                padding: "10px 0 0 0",
              }}
            >
              {itm.tle}
            </Typography>
          </Box>
        ))}
      </Box>
      {RenderComponent()}
    </div>
  );
};

export default CreateNewAccount;
